(() => {
  let opener;
  document.addEventListener('click', event => {
    const button = event.target.closest('#openChat, #openAsk');
    if (button) opener = button;
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.isComposing) return;
    const close = document.querySelector('.sheet.on [data-close]');
    if (close) { event.preventDefault(); close.click(); }
  });
  window.addEventListener('popstate', () => {
    if (!document.body.classList.contains('lock')) opener?.focus({preventScroll:true});
  });
})();
